import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import api from "../api/axios";
import { clearAuth, getUser, getToken } from "../auth/auth";
import Search from "./Search";
import LanguageSwitcher from "./LanguageSwitcher";
import { useTranslation } from "react-i18next";
import Logo from "./Logo";

const Header = ({ cartCount = 0 }) => {
    const token = getToken();
    const user = getUser();
    const { t } = useTranslation();
    
    // ستيت للتحكم في فتح وقفل قائمة الحساب
    const [isProfileOpen, setIsProfileOpen] = useState(false);

    // 👇 السحر هنا: قفل القائمة أوتوماتيك مع تغيير الرابط أو الرجوع
    const location = useLocation();
    useEffect(() => {
        setIsProfileOpen(false);
    }, [location.pathname]);

    const logout = async () => {
        try {
            await api.post("/logout");
        } catch (e) { }
        finally {
            clearAuth();
            window.location.href = "/login";
        }
    };

    return (
        <header className="p-3 border-bottom bg-light">
            <div className="container-fluid">
                <div className="row g-3 align-items-center">
                    
                    <div className="col-md-3 text-center text-md-start">
                        <Link to="/" className="text-decoration-none" title="wageh.store">
                            <Logo width="160" className="hover-opacity transition-all" />
                        </Link>
                    </div>

                    <div className="col-md-5">
                        <Search />
                    </div>

                    <div className="col-md-4 text-center text-md-end d-flex justify-content-center justify-content-md-end align-items-center gap-3 mt-3 mt-md-0">
                        <LanguageSwitcher />

                        <div className="position-relative">
                            <Link to="/cart" className="btn btn-primary px-3 shadow-sm rounded-pill d-flex align-items-center transition-all hover-shadow">
                                <i className="bi bi-cart3 fs-5"></i>
                                <span className="d-none d-sm-inline mx-2 fw-bold">{t("cart", "السلة")}</span>
                                {cartCount > 0 && (
                                    <span className="position-absolute top-0 start-100 translate-middle badge bg-danger rounded-circle border border-light border-2">
                                        {cartCount}
                                    </span>
                                )}
                            </Link>
                        </div>

                        {!token ? (
                            <Link
                                to="/login"
                                className="btn btn-outline-primary rounded-circle d-flex align-items-center justify-content-center transition-all hover-shadow"
                                style={{ width: "45px", height: "45px" }}
                                title={t("login_btn", "تسجيل الدخول")}
                            >
                                <i className="bi bi-person fs-4"></i>
                            </Link>
                        ) : (
                            <div className="dropdown position-relative">
                                <button
                                    type="button"
                                    className="btn btn-primary rounded-circle d-flex align-items-center justify-content-center border-0 shadow-sm transition-all hover-shadow"
                                    onClick={() => setIsProfileOpen(!isProfileOpen)}
                                    style={{ width: "45px", height: "45px" }}
                                >
                                    <i className="bi bi-person-fill text-white fs-4"></i>
                                </button>

                                <ul 
                                    className={`dropdown-menu shadow border-0 mt-2 rounded-3 p-2 ${isProfileOpen ? 'show' : ''}`}
                                    style={{ position: 'absolute', top: '100%', right: '0', zIndex: 1050 }}
                                >
                                    <li>
                                        <span className="dropdown-item-text fw-bold text-primary px-3 py-2">
                                            <i className="bi bi-person-badge me-2"></i> {user?.name}
                                        </span>
                                    </li>
                                    <li><hr className="dropdown-divider opacity-25" /></li>
                                    <li>
                                        <Link className="dropdown-item rounded py-2 px-3 transition-all" to="/profile" onClick={() => setIsProfileOpen(false)}>
                                            <i className="bi bi-person-gear me-2"></i> {t("my_profile", "الملف الشخصي")}
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item rounded py-2 px-3 transition-all" to="/orders" onClick={() => setIsProfileOpen(false)}>
                                            <i className="bi bi-list-check me-2"></i> {t("my_orders", "طلباتي")}
                                        </Link>
                                    </li>
                                    <li><hr className="dropdown-divider opacity-25" /></li>
                                    <li>
                                        <button className="dropdown-item rounded py-2 px-3 text-danger transition-all" onClick={logout}>
                                            <i className="bi bi-box-arrow-right me-2"></i> {t("logout", "تسجيل الخروج")}
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;